import { Capacitor } from '@capacitor/core';

/**
 * True only when running inside the native iOS app (Capacitor WKWebView).
 * Gates the `@capacitor/keyboard` integration in useKeyboardDock (dock position
 * + scoped resize mode); web / other platforms are no-ops.
 */
export const isIosNative = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
